<script>
  // import("@/view/front/views/sitemap")
  // import Multiselect from "../../../../public/sitemap.xml";
  // import { MEDIA_URL } from "@/core/api";
  /**
   * Index-personal component
   */
  export default {
    data() {
      return {
        // MEDIA_URL:MEDIA_URL,
      };
    },
    components: {
      // Multiselect,
    },
    methods:{
      writeFile(){
        const  sitemap = '/sitemap.xml';
        console.log(sitemap);

        // const fs = require('fs');
        // writeFile() {
        //     // if(err) {
        //     //     return console.log(err);
        //     // }
        //     console.log("The file was saved!");
        // } 
      },
    },
  };
  </script>
  
  <template>
    <div @click="writeFile()">
      Hello Site Map
    </div>
  </template>
  